import {
  DOCUMENT_FIELD,
  DOCUMENT_TYPE,
  documentInitialState,
  DocumentState,
  dulInitialState,
  PASSPORT_STATUS,
} from '../constants/document';
import { CITIZENSHIP } from '../constants/citizenship';
import { passportIssueDateValidation, validateField } from '../validators';
import deepmerge from 'deepmerge';
import {
  getErrorPayload,
  transformPayloadToField,
} from '../helpers/fieldHelpers';

const documentModel = {
  state: {
    dul: dulInitialState,
    birthCertificate: {
      ...documentInitialState,
      birthCertificate: true,
      input_type: 'LK',
    },
  },
  reducers: {
    'dul/reset'(state, { payload }) {
      const field = DOCUMENT_FIELD[DOCUMENT_FIELD.dul];
      state[field] = {
        ...documentInitialState,
        birthCertificate: false,
        type: {
          value:
            payload === CITIZENSHIP.CITIZEN ? DOCUMENT_TYPE.PASSPORT_RF : null,
          disabled: false,
          error: false,
        },
      };
      return state;
    },
    'bc/reset'(state) {
      const field = DOCUMENT_FIELD[DOCUMENT_FIELD.birthCertificate];
      state[field] = {
        ...documentInitialState,
        birthCertificate: true,
      };
      return state;
    },
    'document/set'(
      state,
      {
        payload,
        documentField,
      }: { payload: Partial<DocumentState>; documentField: DOCUMENT_FIELD }
    ) {
      if (!payload) return;
      const field = DOCUMENT_FIELD[documentField];
      Object.assign(state[field], payload);
      return state;
    },
    'document/set/values'(state, { payload, documentField }) {
      const field = DOCUMENT_FIELD[documentField];

      const errorPayload = getErrorPayload(payload);
      state[field] = Object.assign(
        state[field],
        transformPayloadToField('value', payload, state[field])
      );

      state[field] = Object.assign(
        state[field],
        transformPayloadToField('error', errorPayload, state[field])
      );

      if (!payload.type) return state;
      state[field] = Object.assign(
        state[field],
        transformPayloadToField(
          'error',
          {
            number: false,
            issuer: false,
            issueDate: false,
            divisionCode: false,
          },
          state[field]
        )
      );
      if (Object.keys(payload).length === 1) {
        state[field] = Object.assign(
          state[field],
          transformPayloadToField<string>(
            'value',
            {
              number: '',
              issuer: '',
              issueDate: '',
              divisionCode: '',
            },
            state[field]
          )
        );
      }
      return state;
    },
    'document/validation/result'(state, { payload }) {
      const { personState, fieldValue } = payload;
      return deepmerge(personState, fieldValue);
    },
    'reset/issueDate'(state) {
      const fields = {
        dul: { issueDate: { error: false } },
        birthCertificate: {
          issueDate: { error: false },
        },
      };
      return deepmerge(state, fields);
    },
    'set/dul/issueDate/error'(state) {
      return deepmerge(state, { dul: { issueDate: { error: true } } });
    },
    'set/bc/issueDate/error'(state) {
      return deepmerge(state, {
        birthCertificate: {
          issueDate: { error: true },
        },
      });
    },
    'set/passport/status'(state, { payload }) {
      return deepmerge(state, { dul: { status: payload } });
    },
    'reset/passport/status'(state, { payload }) {
      return deepmerge(state, { dul: { status: PASSPORT_STATUS.VALID } });
    },
    'set/birthCertificate/input_type'(state, { payload }) {
      state.birthCertificate.input_type = payload;
      return state;
    },
  },
  effects: {
    *'document/validate'({ type, payload, documentField }, { select, put }) {
      const [modelNamespace] = type.split('/');

      const state = yield select((state) => state);

      const field = DOCUMENT_FIELD[documentField];

      const fieldValue = validateField(type, state, field);
      const personState = state[modelNamespace];

      yield put({
        type: 'document/validation/result',
        payload: { personState, fieldValue },
      });
    },
    *'passport/validity'({ type }, { select, put }) {
      const [modelNamespace] = type.split('/');

      const validation = passportIssueDateValidation[modelNamespace];
      const passportStatus = yield select(validation);

      yield put({
        type: 'set/passport/status',
        payload: passportStatus,
      });
    },
  },
};

export default documentModel;
